import { useEffect } from 'react';
import { isFlowToastActive, updateFlowProgress, updateFlowToast } from '../utils/flowToast';

export function useWealthicaFlowProgress(
  wealthicaAccountsLength: number,
  isLoadingPositions: boolean,
  persistDataPreference: boolean
) {
  useEffect(() => {
    if (!isFlowToastActive()) return;
    const haveAccounts = (wealthicaAccountsLength || 0) > 0;
    const positionsSettled = !isLoadingPositions;

    if (haveAccounts && !positionsSettled) {
      try { updateFlowProgress('wealthica-flow', 60, 'Connected. Loading positions…'); } catch {}
      return;
    }

    if (haveAccounts && positionsSettled) {
      if (persistDataPreference) {
        try { updateFlowProgress('wealthica-flow', 85, 'Connected. Saving to your workspace…'); } catch {}
      } else {
        try { updateFlowProgress('wealthica-flow', 100, 'Connected', 'All set'); } catch {}
        try { updateFlowToast('wealthica-flow', 'success', 'Connected'); } catch {}
      }
    }
  }, [wealthicaAccountsLength, isLoadingPositions, persistDataPreference]);
}
